






































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import moment from "moment";

import {
  HsabExpenseByExternalIdRequest,
  HsabExpenseResponse,
  HsabTransactionDetail,
} from "@/shared/types";
import HsabTransactionChildRowItem from "@/shared/components/cash/hsabank/HsabTransactionChildRowItem.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({
  components: {
    GenericLoadingSpinner,
    HsabTransactionChildRowItem,
  }
})
export default class HsabTransactionChildRow extends Vue {
  hsabExpenseStore = useHsabExpenseStore();

  @Prop()
  transaction: HsabTransactionDetail;

  @Prop()
  isOpen: boolean;

  @Prop()
  isNotional: boolean;

  expense: HsabExpenseResponse = null;
  moment = moment;
  isExpenseLoading = false;

  get paymentDate () {
    if (!this.transaction.paymentDate) {
      return "N/A";
    }
    const date = moment(this.transaction.paymentDate);
    if (this.isBogusDate(date)) {
      return "N/A";
    }
    return date.format("MM/DD/YYYY");
  }
  get showEffectiveDate (): boolean {
    return !this.isNotional;
  }

  get effectiveDate () {
    const date = moment(this.transaction.effectiveDate);
    if (this.isBogusDate(date)) {
      return "N/A";
    }
    return date.format("MM/DD/YYYY");
  }

  isBogusDate (date: moment.Moment) {
    return date < moment("1900/01/02");
  }

  get detailChildRowClasses () {
    const expenseRowVisible = this.showExpenseDataColumn;
    return {
      "col-12": true,
      "offset-sm-1": true,
      "col-sm-5": expenseRowVisible,
      "col-md-5": expenseRowVisible,
      "col-lg-4": expenseRowVisible,
      "py-2": true,
      "pl-md-0 ": true
    };
  }

  get expenseProviderLabel () {
    if (!this.expense) {
      return "";
    }

    return this.expense.isPayToPayee ? "Payee Name" : "Provider Name";
  }

  get claimNumber () {
    // EOB number is displayed as claim number for applicable HSA transactions
    if (this.hasClaimNumber()) {
      return this.transaction.claimNumber;
    }
    if (this.transaction.eobNumber) {
      return this.transaction.eobNumber;
    }
    return "N/A";
  }

  get expenseProviderValue () {
    if (this.expense) {
      return this.expense.isPayToPayee ? this.expense.payeeName : this.expense.providerName;
    }

    return "";
  }

  get expenseSendTo () {
    if (this.expense) {
      return this.expense.isPayToPayee ? "Alternate Payee" : "Account Holder";
    }

    return "";
  }

  get externalIdToGetExpenseBy () {
    if (this.hasClaimNumber()) {
      return this.transaction.claimNumber;
    } else if (this.hasFlowId()) {
      return this.transaction.flowId;
    } else {
      return undefined;
    }
  }

  get checkNumber () {
    return !this.transaction.checkNumber ? "N/A" : this.transaction.checkNumber;
  }

  get paymentMethod () {
    return this.transaction.claimPaymentMethod === "None" ? "N/A" : this.transaction.claimPaymentMethod;
  }

  get showExpenseDataColumn (): boolean {
    return this.hasFlowId() || this.hasClaimNumber();
  }

  hasFlowId () {
    return this.transaction && !isNullEmptyOrUndefined(this.transaction.flowId);
  }

  hasClaimNumber () {
    return this.transaction && !isNullEmptyOrUndefined(this.transaction.claimNumber);
  }

  get expenseDateOfService () {
    if (this.expense && this.expense.dateOfService) {
      return moment(this.expense.dateOfService).format("MM/DD/YYYY");
    }

    return "";
  }
  @Watch("isOpen")
  visibilityChanged (isOpened) {
    if (isOpened && this.showExpenseDataColumn) {
      const request: HsabExpenseByExternalIdRequest = {
        externalReimbursementId: this.hasClaimNumber() ? this.transaction.claimNumber : null,
        externalTransactionId: this.hasFlowId() ? this.transaction.flowId : null,
      };
      this.hsabExpenseStore.loadExpenseByExternalId(request).then(
          expense => {
            this.expense = expense ? expense : null;
          }
      );
    }
  }

  @Watch("expenseStore.expensesByExternalIdFetchStateDictionary", { deep: true })
  expenseLoadingChanged () {
    if (this.transaction && this.transaction.eobNumber) {
      this.isExpenseLoading = this.hsabExpenseStore.isExpenseByExternalIdLoading(this.transaction.eobNumber);
    }
  }
}
